/**
 * Composant racine du portfolio.
 *
 * Role : assembler les sections dans l'ordre visible sur la page (Header ->
 * Hero -> Skills -> ... -> Footer). C'est le squelette du site.
 *
 * Pas de routing (`react-router`) : le portfolio est une SPA single-route.
 * Les "pages" sont des sections ancrees (`<section id="skills">`) que le
 * Header scroll-to via des liens `<a href="#skills">`.
 *
 * `<References />` : commente actuellement (pas de temoignages a afficher).
 * Peut etre reactive quand des references seront disponibles.
 *
 * `pt-16` sur `<main>` : compense la hauteur du Header qui est fixe
 * (`position: fixed` en Tailwind). Sans ce padding, la premiere section
 * (Hero) serait cachee derriere le Header.
 */

import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
// import References from './components/References';   // Reactiver quand des temoignages sont disponibles
import Trainings from './components/Trainings';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="pt-16">
        <Hero />
        <Skills />
        <Projects />
        <Certifications />
        <Trainings />
        {/* <References /> */}
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
